import React from 'react'

import { AtsLockContext } from 'components/common/AtsLock'

import { useSelectCandidateModal } from 'components/modals/SelectCandidateModal/hooks'
import { useTestsReportModal } from 'components/modals/TestsReportModal/hooks'
import { useSelectCandidateGroupModal } from 'components/modals/SelectCandidateGroupModal/hooks'
import {
  useCandidateActions,
  useCandidateGroupActions,
  useCandidateState,
  useJobDetailsTab,
  useFilter,
} from './../hooks'

export const useJobTestsTab = state => {
  const { projectId } = state

  const { isAtsLocked } = React.useContext(AtsLockContext) ?? {}

  const status = ['completed']

  const {
    state: { count, search },
    handlers: { setSearch },
  } = useJobDetailsTab()

  const {
    state: { filter },
    handlers: { setFilter },
  } = useFilter()

  const {
    state: {
      candidate,
      selected,
      selectedCandidates,
      hasMoveCandidatesFeature,
    },
    handlers: { setCandidate },
  } = useCandidateState()

  const {
    handleSelectCandidateGroupModalClose,
    handleSelectCandidateGroupModalConfirm,
    handleSelectCandidateGroupModalOpen,
    isSelectCandidateGroupModalOpen,
  } = useSelectCandidateGroupModal({ projectId })

  const {
    handleTestsReportModalClose: closeModal,
    handleTestsReportModalOpen,
    isTestsReportModalOpen,
  } = useTestsReportModal()

  const {
    handleSelectCandidateModalClose,
    handleSelectCandidateModalConfirm,
    handleSelectCandidateModalOpen,
    isSelectCandidateModalOpen,
  } = useSelectCandidateModal({ id: candidate?.id, projectId })

  const {
    state: {
      isCandidateManagementModalOpen,
      isDeleteCandidateModalOpen,
      isMoveCandidateModalOpen,
    },
    handlers: {
      getActions,
      handleFavorite,
      handleCandidateManagementModalClose,
      handleCandidateManagementModalConfirm,
      handleDeleteCandidateModalClose,
      handleDeleteCandidateModalConfirm,
      handleMoveCandidateModalClose,
      handleMoveCandidateModalConfirm,
    },
  } = useCandidateActions(
    { candidate, projectId, status, hasMoveCandidatesFeature, isAtsLocked },
    { handleSetCandidate: setCandidate },
  )

  const {
    state: {
      actions,
      isDeleteCandidateGroupModalOpen,
      isExportCandidateGroupModalOpen,
      isMoveCandidateGroupModalOpen,
    },
    handlers: {
      handleDeleteCandidateGroupModalClose,
      handleDeleteCandidateGroupModalConfirm,
      handleExportCandidateGroupModalClose,
      handleMoveCandidateGroupModalClose,
      handleMoveCandidateGroupModalConfirm,
    },
  } = useCandidateGroupActions({
    projectId,
    selected,
    status,
    hasMoveCandidatesFeature,
    isAtsLocked,
  })

  const hasCandidatesSelected = Object.keys(selected).length > 0
  const hasTwoCandidatesSelected = Object.keys(selected).length === 2

  const handleTestsReport = React.useCallback(
    ({ candidate }) => {
      setCandidate(candidate)
      handleTestsReportModalOpen()
    },
    [handleTestsReportModalOpen, setCandidate],
  )

  const handleTestsReportModalClose = () => {
    setCandidate(null)
    closeModal()
  }

  const handleCompare = () => {
    handleTestsReportModalOpen()
  }

  const handleSelectForInterview = React.useCallback(
    ({ candidate }) => {
      setCandidate(candidate)
      handleSelectCandidateModalOpen()
    },
    [handleSelectCandidateModalOpen, setCandidate],
  )

  return {
    state: {
      actions,
      candidate,
      count,
      search,
      filter,
      selectedCandidates,
      hasCandidatesSelected,
      hasTwoCandidatesSelected,
      hasMoveCandidatesFeature,
      isCandidateManagementModalOpen,
      isDeleteCandidateModalOpen,
      isMoveCandidateModalOpen,
      isTestsReportModalOpen,
      isSelectCandidateModalOpen,
      isDeleteCandidateGroupModalOpen,
      isExportCandidateGroupModalOpen,
      isMoveCandidateGroupModalOpen,
      isSelectCandidateGroupModalOpen,
    },
    handlers: {
      getActions,
      setFilter,
      handleFavorite,
      handleCandidateManagementModalClose,
      handleCandidateManagementModalConfirm,
      handleDeleteCandidateModalClose,
      handleDeleteCandidateModalConfirm,
      handleMoveCandidateModalClose,
      handleMoveCandidateModalConfirm,
      handleSelectCandidateModalClose,
      handleSelectCandidateModalConfirm,
      handleTestsReportModalClose,
      handleDeleteCandidateGroupModalClose,
      handleDeleteCandidateGroupModalConfirm,
      handleExportCandidateGroupModalClose,
      handleMoveCandidateGroupModalClose,
      handleMoveCandidateGroupModalConfirm,
      handleSelectCandidateGroupModalClose,
      handleSelectCandidateGroupModalConfirm,
      handleSelectCandidateGroupModalOpen,
      handleSelectForInterview,
      handleTestsReport,
      handleCompare,
      setSearch,
    },
  }
}
